export const lang = process.env.REACT_APP_LANG;
export const name = process.env.REACT_APP_NAME;
export const apiURL = 'https://api.kpnewss.com/api/v1'; // 'https://localhost:7189/api/v1';
